export const isSameUserId = (firstId, secondId) =>
  firstId != null && secondId != null && String(firstId) === String(secondId);

export const isOwnerProfileView = ({ initCreation, creation, authUserId, sessionUserId }) => {
  const ownerUserId = authUserId ?? sessionUserId;

  return (
    ownerUserId != null &&
    (
      isSameUserId(initCreation?.creator_id, ownerUserId) ||
      isSameUserId(initCreation?.users?.user_id, ownerUserId) ||
      isSameUserId(creation?.creator_id, ownerUserId) ||
      isSameUserId(creation?.users?.user_id, ownerUserId)
    )
  );
};
